"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="CalendarData.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxCalendarData object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxCalendarData = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxColor_1 = require("./HxColor");
var HxCalendarData = /** @class */ (function (_super) {
    __extends(HxCalendarData, _super);
    function HxCalendarData(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxCalendarData, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxCalendarData.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '1FC':
                        this.accountId = new HxObjectID_1.default(v);
                        break;
                    case 'E83':
                        var allowedOnlineMeetingProvidersValues = v;
                        this.allowedOnlineMeetingProviders = new Array(allowedOnlineMeetingProvidersValues.length);
                        for (var i = 0; i < allowedOnlineMeetingProvidersValues.length; i++) {
                            this.allowedOnlineMeetingProviders[i] = allowedOnlineMeetingProvidersValues[i];
                        }
                        break;
                    case '935':
                        this.calendarSharingAttendeesPairId = new HxObjectID_1.default(v);
                        break;
                    case '1038':
                        this.calendarSharingDetailLevel = v;
                        break;
                    case '111F':
                        this.calendarSource = v;
                        break;
                    case '1FD':
                        this.capabilities_CanRead = v;
                        break;
                    case '136A':
                        this.capabilities_CanRename = v;
                        break;
                    case '81B':
                        this.capabilities_CanShare = v;
                        break;
                    case '81C':
                        this.capabilities_CanViewPrivateItems = v;
                        break;
                    case '1FE':
                        this.capabilities_CanWrite = v;
                        break;
                    case '163A':
                        this.capabilities_DeleteItemsPermission = v;
                        break;
                    case '163B':
                        this.capabilities_EditItemsPermission = v;
                        break;
                    case 'E85':
                        this.capabilities_EnableOnlineMeeting = v;
                        break;
                    case '76F':
                        this.capabilities_IsRemovable = v;
                        break;
                    case '770':
                        this.capabilities_SupportsMeetings = v;
                        break;
                    case '12D3':
                        this.capabilities_SupportsTallyingResponses = v;
                        break;
                    case '1F4':
                        this.color = HxColor_1.deserializeHxColor(v);
                        break;
                    case '103A':
                        this.contextId = v;
                        break;
                    case 'E84':
                        this.defaultOnlineMeetingProvider = v;
                        break;
                    case '1F1':
                        this.deviceId = v;
                        break;
                    case '1F3':
                        this.displayName = v;
                        break;
                    case '764':
                        this.familyPuid = v;
                        break;
                    case '3EC':
                        this.folderType = v;
                        break;
                    case '1F5':
                        this.index = v;
                        break;
                    case '1F7':
                        this.isDefault = v;
                        break;
                    case 'EAD':
                        this.isInterestingCalendar = v;
                        break;
                    case 'CA6':
                        this.isSharedWithMe = v;
                        break;
                    case '1F6':
                        this.parentGroupId = v;
                        break;
                    case '111D':
                        this.remoteChangeKey = Buffer.from(v, 'base64');
                        break;
                    case '4DA':
                        this.remoteId = v;
                        break;
                    case '111E':
                        this.remoteServerId = v;
                        break;
                    case '1F0':
                        this.serverId = v;
                        break;
                    case '12DF':
                        this.sharedCalendarCategoriesId = new HxObjectID_1.default(v);
                        break;
                    case '82D':
                        this.sharedOwnerEmailAddress = v;
                        break;
                    case '82E':
                        this.sharedOwnerName = v;
                        break;
                    case '107D':
                        this.shouldFireReminders = v;
                        break;
                    case '481':
                        this.summaryCardView = v;
                        break;
                    case 'D00':
                        this.syncAppointments = v;
                        break;
                    case 'F16':
                        this.syncViewCurrentIteration = v;
                        break;
                    case '1F8':
                        this.view_CalendarState = v;
                        break;
                    case '6B2':
                        this.view_CalendarTheme = v;
                        break;
                    case '1FB':
                        this.view_UseAutomaticColoring = v;
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxCalendarData.prototype.getAccount = function (sessionId) {
        return this.activeSet.getObject(this.accountId, sessionId).then(function (result) { return result; });
    };
    HxCalendarData.prototype.getCalendarSharingAttendeesPair = function (sessionId) {
        return this.activeSet.getObject(this.calendarSharingAttendeesPairId, sessionId).then(function (result) { return result; });
    };
    HxCalendarData.prototype.getSharedCalendarCategories = function (sessionId) {
        return this.activeSet.getCollection(this.sharedCalendarCategoriesId, sessionId);
    };
    return HxCalendarData;
}(HxObject_1.default));
exports.HxCalendarData = HxCalendarData;
exports.default = HxCalendarData;
